import script from "./PageTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./PageTitle.vue?vue&type=script&setup=true&lang=js"

import "./PageTitle.vue?vue&type=style&index=0&id=2469df48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2469df48"]])

export default __exports__